import * as React from "react"
import { useState } from "react"

interface InfoTooltipProps {
  content: string
}

export function InfoTooltip({ content }: InfoTooltipProps) {
  const [show, setShow] = useState(false)

  return (
    <div className="relative inline-block ml-1.5">
      <button
        type="button"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={(e) => {
          e.preventDefault()
          setShow(!show)
        }}
        className="w-4 h-4 rounded-full bg-stone-200 dark:bg-stone-700 text-stone-500 dark:text-stone-400 text-xs flex items-center justify-center hover:bg-stone-300 dark:hover:bg-stone-600 transition-colors"
        aria-label="More information"
      >
        i
      </button>
      {show && (
        <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 p-3 text-xs text-stone-600 dark:text-stone-300 bg-white dark:bg-stone-800 rounded-lg shadow-lg border border-stone-200 dark:border-stone-700 normal-case">
          {content}
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px">
            <div className="w-2 h-2 rotate-45 bg-white dark:bg-stone-800 border-b border-r border-stone-200 dark:border-stone-700" />
          </div>
        </div>
      )}
    </div>
  )
}
